export const categories = [
  { name: '明星塌房', slug: 'star-collapse', icon: 'ri-user-unfollow-line', description: '明星艺人翻车塌房全记录' },
  { name: '网红黑料', slug: 'influencer-dirt', icon: 'ri-spy-line', description: '网红主播不为人知的另一面' },
  { name: '反差视频', slug: 'contrast-video', icon: 'ri-film-line', description: '人前人后两幅面孔大曝光' },
  { name: '聊天记录', slug: 'chat-logs', icon: 'ri-message-2-line', description: '私密对话截图全网首发' },
  { name: '每日大赛', slug: 'daily-contest', icon: 'ri-fire-line', description: '每日最新吃瓜现场直击' },
  { name: '娱乐圈', slug: 'entertainment', icon: 'ri-vip-crown-line', description: '娱乐圈不雅八卦深扒' },
];

export const featuredArticles = [
  {
    id: '1',
    slug: 'top-star-scandal-2026',
    title: '顶流男星深夜密会神秘女子，酒店监控画面曝光引热议',
    excerpt: '据知情人士透露，该男星与神秘女子在酒店共处超过8小时，期间多次出入同一房间。网友扒出女方疑似某知名网红，两人此前曾在社交平台有过互动。',
    category: '明星塌房',
    categorySlug: 'star-collapse',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20moody%20night%20scene%20with%20silhouette%20of%20a%20person%20walking%20into%20a%20luxury%20hotel%20entrance%2C%20warm%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20cinematic%20atmosphere%2C%20mysterious%20vibe%2C%20soft%20bokeh%20background%2C%20film%20noir%20style%2C%20golden%20and%20amber%20tones&width=800&height=500&seq=gossip-hero-01&orientation=landscape',
    date: '2026-06-28',
    views: 1289300,
    hot: true,
    tags: ['顶流', '出轨', '酒店'],
  },
  {
    id: '2',
    slug: 'influencer-live-broadcast-scandal',
    title: '千万粉网红直播翻车！意外曝光私密聊天记录，内容劲爆',
    excerpt: '该网红在直播过程中不慎打开微信，聊天列表中的多个暧昧对象截图被网友截图疯传。其中涉及多名圈内知名人士，内容尺度之大令人瞠目。',
    category: '网红黑料',
    categorySlug: 'influencer-dirt',
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20chat%20messages%20with%20blurred%20content%2C%20dramatic%20lighting%20from%20ring%20light%2C%20streaming%20setup%20background%2C%20modern%20bedroom%20atmosphere%2C%20warm%20pink%20and%20amber%20tones%2C%20cinematic%20depth%20of%20field&width=800&height=500&seq=gossip-hero-02&orientation=landscape',
    date: '2026-06-27',
    views: 987200,
    hot: true,
    tags: ['直播', '翻车', '聊天记录'],
  },
  {
    id: '3',
    slug: 'actress-secret-relationship',
    title: '当红女星被曝隐婚生子？前助理实锤爆料引爆全网',
    excerpt: '一位自称该女星前助理的网友在社交平台发布长篇爆料，详细描述了该女星秘密结婚生子的全过程，并晒出多张据称是内部工作群的聊天截图。',
    category: '明星塌房',
    categorySlug: 'star-collapse',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20paparazzi%20style%20photography%20of%20a%20person%20covered%20with%20a%20coat%20rushing%20into%20a%20black%20van%2C%20flashing%20cameras%20in%20background%2C%20night%20scene%2C%20high%20contrast%2C%20news%20scandal%20vibe%2C%20warm%20street%20lights%2C%20tense%20atmosphere&width=800&height=500&seq=gossip-hero-03&orientation=landscape',
    date: '2026-06-26',
    views: 756400,
    hot: true,
    tags: ['女星', '隐婚', '实锤'],
  },
  {
    id: '4',
    slug: 'variety-show-controversy',
    title: '综艺节目录制现场冲突！两位导师当场互撕，节目组紧急叫停',
    excerpt: '据现场观众爆料，两位导师因对选手评分意见不合，在录制现场激烈争吵，其中一人甚至摔麦离场。节目组随后宣布暂停录制，目前该期节目能否播出成谜。',
    category: '娱乐圈',
    categorySlug: 'entertainment',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20dramatic%20red%20and%20blue%20stage%20lighting%2C%20two%20empty%20judge%20chairs%20facing%20each%20other%2C%20tension%20in%20the%20air%2C%20scattered%20papers%20on%20the%20floor%2C%20behind%20the%20scenes%20drama%2C%20warm%20theatrical%20spotlights&width=800&height=500&seq=gossip-hero-04&orientation=landscape',
    date: '2026-06-25',
    views: 623100,
    hot: false,
    tags: ['综艺', '互撕', '导师'],
  },
];

export const latestArticles = [
  {
    id: '5',
    slug: 'boy-band-member-dating',
    title: '男团成员深夜与女粉丝私会，监控拍下全程',
    excerpt: '狗仔蹲守多日终于拍到实锤画面，该男团成员凌晨两点带女粉丝返回住所...',
    category: '明星塌房',
    categorySlug: 'star-collapse',
    imageUrl: 'https://readdy.ai/api/search-image?query=Night%20street%20scene%20with%20two%20silhouetted%20figures%20walking%20close%20together%20under%20a%20dim%20streetlamp%2C%20apartment%20building%20in%20background%2C%20surveillance%20camera%20angle%2C%20warm%20amber%20lighting%2C%20secretive%20atmosphere%2C%20soft%20grainy%20texture&width=600&height=400&seq=gossip-latest-01&orientation=landscape',
    date: '2026-06-28',
    views: 452100,
    hot: true,
    tags: ['男团', '私会', '粉丝'],
  },
  {
    id: '6',
    slug: 'beauty-blogger-fake-products',
    title: '美妆博主带货假货被扒！品牌方发律师函',
    excerpt: '该博主直播间售卖的美妆产品被网友送去鉴定，结果全部为假货。品牌方已发律师函...',
    category: '网红黑料',
    categorySlug: 'influencer-dirt',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cosmetic%20products%20scattered%20on%20a%20vanity%20table%20with%20a%20magnifying%20glass%20revealing%20fake%20labels%2C%20soft%20ring%20light%20illumination%2C%20beauty%20influencer%20setup%2C%20warm%20pink%20tones%2C%20investigative%20vibe&width=600&height=400&seq=gossip-latest-02&orientation=landscape',
    date: '2026-06-28',
    views: 387600,
    hot: true,
    tags: ['美妆', '假货', '带货'],
  },
  {
    id: '7',
    slug: 'actor-tax-evasion',
    title: '知名演员涉嫌偷税漏税被约谈，金额高达数千万',
    excerpt: '税务部门已介入调查，该演员近三年申报收入与实际收入严重不符...',
    category: '明星塌房',
    categorySlug: 'star-collapse',
    imageUrl: 'https://readdy.ai/api/search-image?query=Official%20government%20building%20entrance%20with%20blurred%20person%20entering%2C%20serious%20atmosphere%2C%20warm%20afternoon%20light%2C%20formal%20setting%2C%20investigative%20journalism%20style%2C%20clean%20minimal%20composition&width=600&height=400&seq=gossip-latest-03&orientation=landscape',
    date: '2026-06-27',
    views: 521000,
    hot: true,
    tags: ['偷税', '演员', '调查'],
  },
  {
    id: '8',
    slug: 'streamer-gambling-scandal',
    title: '游戏主播被曝组织网络赌博，直播间成赌场',
    excerpt: '该主播利用直播间抽奖功能变相组织赌博活动，涉案金额惊人...',
    category: '网红黑料',
    categorySlug: 'influencer-dirt',
    imageUrl: 'https://readdy.ai/api/search-image?query=Gaming%20streaming%20room%20with%20multiple%20monitors%20displaying%20casino-like%20interfaces%2C%20dramatic%20RGB%20lighting%2C%20dark%20atmosphere%2C%20high%20stakes%20vibe%2C%20warm%20neon%20accents%2C%20cinematic%20composition&width=600&height=400&seq=gossip-latest-04&orientation=landscape',
    date: '2026-06-27',
    views: 298400,
    hot: false,
    tags: ['主播', '赌博', '直播间'],
  },
  {
    id: '9',
    slug: 'singer-plagiarism',
    title: '新晋歌手新歌被指抄袭，旋律与国外歌曲高度相似',
    excerpt: '音乐博主制作对比视频，两首歌的副歌部分相似度超过80%...',
    category: '娱乐圈',
    categorySlug: 'entertainment',
    imageUrl: 'https://readdy.ai/api/search-image?query=Music%20studio%20with%20sheet%20music%20papers%20scattered%2C%20headphones%20on%20a%20mixing%20console%2C%20warm%20studio%20lighting%2C%20creative%20atmosphere%2C%20two%20music%20scores%20side%20by%20side%20showing%20similarities&width=600&height=400&seq=gossip-latest-05&orientation=landscape',
    date: '2026-06-26',
    views: 345200,
    hot: false,
    tags: ['抄袭', '歌手', '新歌'],
  },
  {
    id: '6b',
    slug: 'influencer-couple-breakup',
    title: '网红情侣官宣分手！男方被扒出轨多名女粉丝',
    excerpt: '女方发长文控诉男方在恋爱期间多次出轨，受害者联合发声组建维权群...',
    category: '网红黑料',
    categorySlug: 'influencer-dirt',
    imageUrl: 'https://readdy.ai/api/search-image?query=Broken%20heart%20symbolism%20with%20cracked%20phone%20screen%20displaying%20social%20media%20post%2C%20dark%20moody%20bedroom%2C%20warm%20dim%20lighting%2C%20emotional%20atmosphere%2C%20soft%20focus%2C%20melancholic%20vibe&width=600&height=400&seq=gossip-latest-06&orientation=landscape',
    date: '2026-06-26',
    views: 612800,
    hot: true,
    tags: ['情侣', '出轨', '分手'],
  },
];

export const hotTopics = [
  {
    id: 'h1',
    slug: 'top-star-scandal-2026',
    title: '顶流男星深夜密会神秘女子，酒店监控画面曝光',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20corridor%20at%20night%20with%20surveillance%20camera%20angle%2C%20warm%20hallway%20lighting%2C%20empty%20corridor%20with%20room%20doors%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20soft%20golden%20tones&width=400&height=300&seq=gossip-hot-01&orientation=landscape',
    views: 1289300,
    comments: 52800,
    rank: 1,
  },
  {
    id: 'h2',
    slug: 'influencer-couple-breakup',
    title: '网红情侣官宣分手！男方被扒出轨多名女粉丝',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20people%20standing%20back%20to%20back%20in%20a%20dark%20room%2C%20dramatic%20split%20lighting%2C%20warm%20and%20cold%20tones%20contrast%2C%20emotional%20separation%20concept%2C%20cinematic%20portrait%20style%2C%20soft%20shadows&width=400&height=300&seq=gossip-hot-02&orientation=landscape',
    views: 612800,
    comments: 35100,
    rank: 2,
  },
  {
    id: 'h3',
    slug: 'actor-tax-evasion',
    title: '知名演员涉嫌偷税漏税被约谈，金额数千万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stacks%20of%20documents%20and%20calculators%20on%20a%20dark%20wooden%20desk%2C%20warm%20desk%20lamp%20lighting%2C%20serious%20financial%20investigation%20theme%2C%20shallow%20depth%20of%20field%2C%20professional%20atmosphere&width=400&height=300&seq=gossip-hot-03&orientation=landscape',
    views: 521000,
    comments: 28900,
    rank: 3,
  },
  {
    id: 'h4',
    slug: 'boy-band-member-dating',
    title: '男团成员深夜与女粉丝私会，监控拍下全程',
    imageUrl: 'https://readdy.ai/api/search-image?query=Apartment%20building%20entrance%20at%20night%20with%20security%20camera%20angle%2C%20warm%20street%20light%2C%20a%20couple%20silhouette%20entering%20doorway%2C%20secretive%20atmosphere%2C%20grainy%20surveillance%20footage%20aesthetic&width=400&height=300&seq=gossip-hot-04&orientation=landscape',
    views: 452100,
    comments: 21300,
    rank: 4,
  },
  {
    id: 'h5',
    slug: 'actress-secret-relationship',
    title: '当红女星被曝隐婚生子？前助理实锤爆料',
    imageUrl: 'https://readdy.ai/api/search-image?query=Anonymous%20person%20typing%20on%20a%20laptop%20in%20a%20dark%20room%2C%20only%20screen%20light%20illuminating%20face%2C%20whistleblower%20vibe%2C%20dramatic%20lighting%2C%20warm%20screen%20glow%2C%20suspenseful%20atmosphere&width=400&height=300&seq=gossip-hot-05&orientation=landscape',
    views: 756400,
    comments: 42200,
    rank: 5,
  },
];

export const footerLinks = {
  categories: [
    { name: '明星塌房', slug: 'star-collapse' },
    { name: '网红黑料', slug: 'influencer-dirt' },
    { name: '反差视频', slug: 'contrast-video' },
    { name: '聊天记录', slug: 'chat-logs' },
    { name: '每日大赛', slug: 'daily-contest' },
    { name: '娱乐圈', slug: 'entertainment' },
  ],
  quickLinks: [
    { name: '关于我们', slug: 'about' },
    { name: '最新猛料', slug: 'category/star-collapse' },
    { name: '热门排行', slug: 'category/daily-contest' },
    { name: '投稿爆料', slug: 'about#submit' },
  ],
  legal: [
    { name: '隐私政策', slug: 'about#privacy' },
    { name: '用户协议', slug: 'about#terms' },
    { name: '免责声明', slug: 'about#disclaimer' },
  ],
};
